export default __webpack_public_path__ + "static/media/medical-shield.77b97dcb.svg";